import classnames from 'classnames';
import React from 'react';

import ImageWithTransition from '@cineamo/ui/src/image/ImageWithTransition';

type PreviewImageProps = {
    className?: string;
    src: string;
    alt: string;
    onClick?: () => void;
};
export default function PreviewImage(props: PreviewImageProps): React.JSX.Element {
    return (
        <div
            className={classnames(props.className, 'relative h-full overflow-hidden', {
                'cursor-pointer clickable-element': !!props.onClick
            })}
            onClick={props.onClick}>
            <ImageWithTransition
                className="w-full h-full object-cover hover:scale-105 duration-200"
                src={props.src}
                alt={props.alt}
                width={800}
                height={800}
                priority
            />
        </div>
    );
}
